import moment from "moment-timezone";

export const APP_ROUTES = {
  dashboard: "/dashboard",
  status: "/status",
  monitor: "/monitor",
  monitorInternal: "/monitor-internal",
  analytics: "/api-usage",
  logs: "/logs",
  integrations: "/integrations",
  newIntegration: "/integrations/new",
  integrationSettings: "/integrations/settings",
  manageProviders: "/integrations/providers",
  manageStore: "/integrations/stores",
  managePartner: "/integrations/partners",
  providerConfig: "/integrations/provider",
  storeConfig: "/integrations/store/new",
  auditLogs: "/integrations/audit-logs",
  storeConfigId: "/integrations/setting/store",
  partnerConfig: "/integrations/partner",
  gettingStarted: "/gettingStarted",
  invoices: "/invoices",
  users: "/users",
  settings: "/settings",
  support: "/support",
  // tenantDataIngested: '/tenants/:tenantId/data-ingested',
  // tenantUserAccount: '/tenants/:tenantId/user-accounts',
  login: "/login",
};

export enum FILTER_TYPE {
  type = "KhumbuService",
  subType = "API",
  providersName = "Providers",
  partnersName = "Partners",
  status = "Status",
}

export const TIMEZONE = moment.tz.guess();

export const VIEWMODE = {
  LIGHT: "light",
  DARK: "dark",
};

export const INTEGRATIONS_STEPS_ENUM = {
  SELECT_PROVIDER: "SELECT_PROVIDER",
  SELECT_PARTNER: "SELECT_PARTNER",
  PROVIDER_CONFIG: "PROVIDER_CONFIG",
  PARTNER_CONFIG: "PARTNER_CONFIG",
};

export const INTEGRATIONS_STEPS: any = {
  SELECT_PROVIDER: {
    // step: "Select Povider",
    step: "Add New Integration",
    nextStepText: "Next: Select Partner",
    nextStep: "SELECT_PARTNER",
  },
  SELECT_PARTNER: {
    // step: "Select Integration",
    step: "Add New Integration",
    nextStepText: "Next: Market Config",
    prevStep: "SELECT_PROVIDER",
    nextStep: "MARKET_CONFIG",
  },
  MARKET_CONFIG: {
    step: "Add New Integration",
    prevStep: "SELECT_PARTNER",
    nextStepText: "Confirm",
  },
};

export const initialAlert = {
  title: "",
  text: "",
  buttonText: "",
  icon: null,
  onHandlePress: null,
  component: null,
  buttonText2: "",
  onHandlePress2: null,
  subtitle: "",
  snackType: undefined,
  snack: false,
  noTextMargin: false,
  showText: false,
  notCloseOnSubmit: false,
  inputType: "text",
  buttonWrapperStyle: {},
  buttonStyle: {},
  allowedText: "",
  inputText: "",
  onModelClose: null,
};

export const STATUS_COLOR: any = {
  GREEN: "#07DB3E",
  ORANGE: "#F8A647",
  RED: "#F71631",
};

export const errorMessages: any = {
  204: "I'm performing deep research on your content to ensure I can be as valuable to you as possible! Please check back here.",
  400: `Sorry I could not find enough content to populate the data here.`,
  500: `We are experiencing a brief interruption. We promise to be back shortly and apologize for the inconvenience. Thank you for your patience`,
  404: `Sorry I could not find enough content to populate the data here.`,
};

export enum ROLE {
  ADMIN = "ADMIN",
  DEVELOPER = "DEVELOPER",
  SUPPORT = "SUPPORT",
  PROVIDER_ADMIN = "PROVIDER_ADMIN",
  PROVIDER_DEV = "PROVIDER_DEV",
  PROVIDER_SUPPORT = "PROVIDER_SUPPORT",
  FRANCHISE_SUPPOR = "FRANCHISE_SUPPORT",
}

export enum INTEGRATIONSTATUS {
  PUBLISHED = "PUBLISHED",
  UNDERREVIEW = "UNDERREVIEW",
}

export enum ProviderUser {
  Admin = "PROVIDER_ADMIN",
  Support = "PROVIDER_SUPPORT",
  Developer = "PROVIDER_DEV",
}
export enum AdminUser {
  Admin = "ADMIN",
  Support = "SUPPORT",
  Developer = "DEVELOPER",
}
export enum Franchise {
  Admin = "FRANCHISE_ADMIN",
  Support = "FRANCHISE_SUPPORT",
  Developer = "FRANCHISE_DEVELOPER",
}
export const providerUser = [
  ProviderUser.Admin,
  ProviderUser.Developer,
  ProviderUser.Support,
];
export const franchiseUser = [
  Franchise.Admin,
  Franchise.Developer,
  Franchise.Support,
];

export enum AccessKey {
  DASHBOARD = "DASHBOARD",
  STATUS = "STATUS",
  MONITOR = "MONITOR",
  MONITOR_INTERNAL = "MONITOR_INTERNAL",
  LOGS = "LOGS",
  ANALYTICS = "API_USAGE",
  INTEGRATION = "INTEGRATION",
  SUPPORT = "SUPPORT",
  USER_MANAGEMENT = "USER_MANAGEMENT",
}

// Search options for logs search functionality
export const SEARCH_OPTIONS = [
  { value: 'PROVIDER_ID', label: 'Provider ID' },
  { value: 'PROVIDER_STORE_ID', label: 'Provider Store ID' },
  { value: 'INTEGRATION_ID', label: 'Integration ID' },
  { value: 'INTEGRATION_STORE_ID', label: 'Integration Store ID' },
  { value: 'CORRELATION_ID', label: 'Correlation ID' },
];
